export const PATHNAME = {
  edit: "/edit",
  create: "create",
  vimeoSettings: "/vimeo-settings",
  testimonials: "/testimonials",
  appointments: "/appointments",
  payments: "/payments",
  heroSection: "/hero-section",
  menuSlider: "/menu-slider",
  pickupDelivery: "/pickup-delivery",
  products: "/products",
  contactUsContacts: "/contact-us/contacts",
  contactUsLocations: "/contact-us/locations",
  contactUsSocialMedia: "/contact-us/social-media",
  contactUsMetaDetails: "/contact-us/meta-details",
  about: "/about",
  aboutStats: "/about-stats",
  aboutStatsSection: "/about-stats-section",
  aboutImages: "/about-images",
  homeMetaDetails: "/home-meta-details",
  galleryMetaDetails: "/gallery-meta-details",
  aboutMetaDetails: "/about-meta-details",
  menuCategories: "/menu-categories",
  menuMetaDetails: "/menu-meta-details",
  privacyPolicy: "/privacy-policy-content",
  privacyPolicyMetaDetails: "/privacy-policy-meta-details",
};

export const PATHS_WITH_SEARCH = [];
